/**
 * Split the dynamic-form selection into the id the REQUEST carries and the id
 * the COLUMNS follow.
 *
 * These were one value, defaulting to the active form — so a fresh visit sent
 * `dynamic_form_id=<default>` on every query and filtered the whole result set
 * to one form without the user ever choosing it. Columns still need the active
 * form (it supplies the dynamic column set), which is why the two ids differ:
 * `displayFormId` falls back to the active form, `apiFormId` never does.
 */
export function resolveSearchFormIds(
  urlFormId: string,
  activeFormId?: number
): { displayFormId?: number; apiFormId?: number; isAllSelected: boolean } {
  const explicitId =
    urlFormId && urlFormId !== 'all' ? Number(urlFormId) : undefined;
  const isAllSelected = explicitId === undefined;

  return {
    displayFormId: explicitId ?? activeFormId,
    apiFormId: explicitId,
    isAllSelected
  };
}
